import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '../../../providers/amplify.service';

function PhotoPickerIonicComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 10);
} }
function PhotoPickerIonicComponent_img_6_Template(rf, ctx) { if (rf & 1) {
    var _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "img", 11);
    ɵngcc0.ɵɵlistener("error", function PhotoPickerIonicComponent_img_6_Template_img_error_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onPhotoError(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r1.photoUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function PhotoPickerIonicComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    var _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 12);
    ɵngcc0.ɵɵlistener("click", function PhotoPickerIonicComponent_button_9_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.uploadFile(); });
    ɵngcc0.ɵɵtext(1, " Upload Photo ");
    ɵngcc0.ɵɵelementEnd();
} }
function PhotoPickerIonicComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    var _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵelementStart(2, "span", 15);
    ɵngcc0.ɵɵtext(3, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 16);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "a", 17);
    ɵngcc0.ɵɵlistener("click", function PhotoPickerIonicComponent_div_10_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r9); var ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onAlertClose(); });
    ɵngcc0.ɵɵtext(7, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.errorMessage);
} }
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, Inject } from '@angular/core';
import { AmplifyService } from '../../../providers/amplify.service';
import { PhotoPickerComponentCore } from './photo-picker.component.core';
var template = "\n<div class=\"amplify-photo-picker\">\n<div class=\"amplify-photo-picker-container\">\n  <div class=\"amplify-form-header\">Select Photos</div>\n  <div class=\"amplify-photo-picker-upload\" *ngIf=\"!hasPhoto\"></div>\n  <div class=\"amplify-photo-picker-preview\">\n    <img\n      class=\"amplify-photo-picker-preview\"\n      src=\"{{photoUrl}}\"\n      *ngIf=\"hasPhoto\"\n      (error)=\"onPhotoError()\"\n    />\n  </div>\n  <div class=\"amplify-upload-input\">\n    <input type=\"file\" \n      accept=\"image/*\"\n      (change)=\"pick($event)\"/>\n      <button \n        *ngIf=\"hasPhoto\" \n        class=\"amplify-form-button amplify-upload-button\" \n        (click)=\"uploadFile()\">\n        Upload Photo\n      </button>\n  </div>\n</div>\n<div class=\"amplify-alert\" *ngIf=\"errorMessage\">\n  <div class=\"amplify-alert-body\">\n    <span class=\"amplify-alert-icon\">&#9888;</span>\n    <div class=\"amplify-alert-message\">{{ errorMessage }}</div>\n    <a class=\"amplify-alert-close\" (click)=\"onAlertClose()\">&times;</a>\n  </div>\n</div>\n</div>\n";
var PhotoPickerIonicComponent = /** @class */ (function (_super) {
    __extends(PhotoPickerIonicComponent, _super);
    function PhotoPickerIonicComponent(amplifyService) {
        var _this = _super.call(this, amplifyService) || this;
        _this.amplifyService = amplifyService;
        return _this;
    }
    /** @nocollapse */
    PhotoPickerIonicComponent.ctorParameters = function () { return [
        { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] },] },
    ]; };
PhotoPickerIonicComponent.ɵfac = function PhotoPickerIonicComponent_Factory(t) { return new (t || PhotoPickerIonicComponent)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
PhotoPickerIonicComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PhotoPickerIonicComponent, selectors: [["amplify-photo-picker-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 11, vars: 4, consts: [[1, "amplify-photo-picker"], [1, "amplify-photo-picker-container"], [1, "amplify-form-header"], ["class", "amplify-photo-picker-upload", 4, "ngIf"], [1, "amplify-photo-picker-preview"], ["class", "amplify-photo-picker-preview", 3, "src", "error", 4, "ngIf"], [1, "amplify-upload-input"], ["type", "file", "accept", "image/*", 3, "change"], ["class", "amplify-form-button amplify-upload-button", 3, "click", 4, "ngIf"], ["class", "amplify-alert", 4, "ngIf"], [1, "amplify-photo-picker-upload"], [1, "amplify-photo-picker-preview", 3, "src", "error"], [1, "amplify-form-button", "amplify-upload-button", 3, "click"], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], [1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function PhotoPickerIonicComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3, "Select Photos");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, PhotoPickerIonicComponent_div_4_Template, 1, 0, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, PhotoPickerIonicComponent_img_6_Template, 1, 1, "img", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵelementStart(8, "input", 7);
        ɵngcc0.ɵɵlistener("change", function PhotoPickerIonicComponent_Template_input_change_8_listener($event) { return ctx.pick($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, PhotoPickerIonicComponent_button_9_Template, 2, 0, "button", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, PhotoPickerIonicComponent_div_10_Template, 8, 1, "div", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hasPhoto);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasPhoto);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasPhoto);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorMessage);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PhotoPickerIonicComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-photo-picker-ionic',
                template: template
            }]
    }], function () { return [{ type: ɵngcc2.AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, null); })();
    return PhotoPickerIonicComponent;
}(PhotoPickerComponentCore));
export { PhotoPickerIonicComponent };

